import styled from "styled-components";
import * as React from "react";

const StyledCard = styled.div`
  background-color: var(--card, #fff);
  color: var(--card-foreground, #222);
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
  border-radius: 0.75rem;
  border: 1px solid var(--border, #e5e7eb);
  padding-top: 1.5rem;
  padding-bottom: 1.5rem;
  box-shadow: 0 1px 2px 0 rgb(0 0 0 / 0.05);
`;

const StyledCardHeader = styled.div`
  display: grid;
  grid-auto-rows: min-content;
  grid-template-rows: auto auto;
  align-items: start;
  gap: 0.375rem;
  padding-left: 1.5rem;
  padding-right: 1.5rem;

  &.border-b {
    padding-bottom: 1.5rem;
  }
`;

const StyledCardTitle = styled.div`
  font-weight: 600;
  line-height: 1;
`;

const StyledCardDescription = styled.div`
  color: var(--muted-foreground, #6b7280);
  font-size: 0.875rem;
`;

const StyledCardAction = styled.div`
  grid-column-start: 2;
  grid-row-start: 1;
  grid-row-end: span 2;
  align-self: start;
  justify-self: end;
`;

const StyledCardContent = styled.div`
  padding-left: 1.5rem;
  padding-right: 1.5rem;
`;

const StyledCardFooter = styled.div`
  display: flex;
  align-items: center;
  padding-left: 1.5rem;
  padding-right: 1.5rem;

  &.border-t {
    padding-top: 1.5rem;
  }
`;

function Card({ className, ...props }: React.ComponentProps<"div">) {
  return <StyledCard data-slot="card" className={className} {...props} />;
}
function CardHeader({ className, ...props }: React.ComponentProps<"div">) {
  return (
    <StyledCardHeader
      data-slot="card-header"
      className={className}
      {...props}
    />
  );
}
function CardTitle({ className, ...props }: React.ComponentProps<"div">) {
  return (
    <StyledCardTitle data-slot="card-title" className={className} {...props} />
  );
}
function CardDescription({ className, ...props }: React.ComponentProps<"div">) {
  return (
    <StyledCardDescription
      data-slot="card-description"
      className={className}
      {...props}
    />
  );
}
function CardAction({ className, ...props }: React.ComponentProps<"div">) {
  return (
    <StyledCardAction
      data-slot="card-action"
      className={className}
      {...props}
    />
  );
}
function CardContent({ className, ...props }: React.ComponentProps<"div">) {
  return (
    <StyledCardContent
      data-slot="card-content"
      className={className}
      {...props}
    />
  );
}
function CardFooter({ className, ...props }: React.ComponentProps<"div">) {
  return (
    <StyledCardFooter
      data-slot="card-footer"
      className={className}
      {...props}
    />
  );
}

export {
  Card,
  CardHeader,
  CardFooter,
  CardTitle,
  CardAction,
  CardDescription,
  CardContent,
};
